import { acceptHMRUpdate, defineStore } from 'pinia'
import achievementsService from '@/services/achievements.service'

export const useAchievementsStore = defineStore({
  id: 'achievementsStore',
  state: () => ({
    achievementsAwards: [],
    totalUserCanDonatableAwards: 0,
    myPoint: '0',
    specialModePoints: 0,
    selectedDonateAwardId: '',
    selectedDonateAward: '',
    awardFilter: {
      sort: '',
      direction: '',
      query: ''
    }
  }),
  setup () {},
  actions: {
    getAchievementsList () {
      return achievementsService.getAchievementsList().then(
        response => {
          const awards = response.data.awards || response.data.books || []
          const availableAwards = response.data.availableAwards || response.data.avaibleBooks || []

          this.achievementsAwards = awards
          this.totalUserCanDonatableAwards = Array.isArray(availableAwards)
            ? availableAwards.length
            : 0
          this.myPoint = response.data.userPoint
          this.specialModePoints = response.data.specialModePoints || 0
          return response
        }
      )
    },
    sendPointCode (code) {
      const formData = {
        code: code
      }
      return achievementsService.sendPointCode(formData).then(
        response => {
          return response
        }
      )
    },
    setSelectedDonateAwardId () {
      const formData = {
        id: this.selectedDonateAward.id
      }
      return achievementsService.setSelectedDonateAwardId(formData).then(
        response => {
          return response
        }
      )
    },
    getAwardFilter () {
      return achievementsService.getAchievementsFilterList('?sort=' + this.awardFilter.sort + '&direction=' + this.awardFilter.direction + '&query=' + this.awardFilter.query).then(
        response => {
          this.achievementsAwards = response.data.awards || response.data.books || []
          return response
        }
      )
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAchievementsStore, import.meta.hot))
}
